import { useEffect } from 'react';
import { useThemeSchedule } from '@/hooks/useThemeSchedule';

export function ThemeScheduleProvider({ children }: { children: React.ReactNode }) {
  // This hook will automatically manage the theme based on user preferences
  useThemeSchedule();

  return <>{children}</>;
}
